import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { GQLPlatformCardsFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { ButtonSize, OutlineLinkButton, Pill, RichText, TransparentLinkButton } from '@theprintbar/ui';

interface PlatformCardsProps {
	content: GQLPlatformCardsFragment;
}

const colours = ['bg-blue-bright', 'bg-yellow', 'bg-green', 'bg-orange', 'bg-pink'];

export const PlatformCards = ({ content }: PlatformCardsProps) => {
	return !!content.platformCards.structure ? (
		<div className="mx-4 lg:mx-8">
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
				{content.platformCards.structure.map((item, index) =>
					item ? (
						<div className="rounded-3xl border border-blue py-10 px-4 relative" key={index}>
							<Pill
								className="absolute -top-3 left-4 z-10 mb-3 uppercase text-sm bg-blue-bright font-bold uppercase"
								style={{ backgroundColor: item.colour || colours[index] }}
							>
								{item.title}
							</Pill>
							<div className="flex gap-4">
								{item.image && (
									<div className="relative w-32 h-32 rounded-lg overflow-hidden">
										<img
											loading="lazy"
											src={item.image.image.url}
											alt={item.image.altText || 'icon image'}
											className="absolute top-0 right-0 aspect-square object-cover w-full h-full"
										/>
									</div>
								)}

								<div className="flex flex-col grow-0">
									<div className="mb-8">
										<RichText className="text-sm" {...item.text} />
									</div>
									<div className="flex gap-2 mt-auto justify-self-end">
										{!!item.buttonLink && (
											<OutlineLinkButton
												size={ButtonSize.M}
												className="uppercase font-bold"
												to={item.buttonLink}
												icon={ArrowRightIcon}
											>
												{item?.buttonText}
											</OutlineLinkButton>
										)}
										{!!item.buttonSecondaryLink && (
											<TransparentLinkButton
												size={ButtonSize.M}
												className="uppercase font-bold"
												to={item.buttonSecondaryLink}
												icon={ArrowRightIcon}
											>
												{item.buttonSecondaryText}
											</TransparentLinkButton>
										)}
									</div>
								</div>
							</div>
						</div>
					) : null,
				)}
			</div>
		</div>
	) : null;
};
